import * as React from "react";
import { UitkBadge } from "uitk-react-badge";
import { UitkIcon } from "uitk-react-icons";
import { AllInclusiveContent } from "src/typings/microserviceModels/hotels-flex-module";

export function HotelAllInclusiveBadge(props: AllInclusiveContent) {
  const { title, contentText } = props;

  return (
    <UitkBadge text={title} className="all-t-margin-three all-l-margin-three hotelBadge">
      <UitkIcon name={contentText} />
    </UitkBadge>
  );
}
